export default {
  venues: [],
  venue: undefined,
};
